import { CreateControllerFn } from '@wix/yoshi-flow-editor';
import { searchResultsControllerFactory } from './Widget/platform/searchResultsControllerFactory';
import {
  createGetAppSettings,
  createSearchSDK,
} from '../../lib/extendControllerParams';
import { createSearchLocation } from '../../lib/location';

const createController: CreateControllerFn = async (params) => {
  const { flowAPI, controllerConfig } = params;
  const getAppSettings = createGetAppSettings(params);
  const { isProductSlotInstalled } = await getAppSettings();

  return searchResultsControllerFactory({
    ...controllerConfig,
    getAppSettings,
    searchLocation: createSearchLocation(controllerConfig.wixCodeApi),
    searchSDK: createSearchSDK(params, {
      useRawProductDocuments: isProductSlotInstalled,
    }),
    flowAPI,
    isProductSlotInstalled,
  });
};

export default createController;
